/* eslint-disable */

export async function setStorage(key, value) {
  try {
    await localStorage.setItem(key, value);
  } catch (e) {
    console.log(`setStorage: Error setting key [${key}]: ${JSON.stringify(e)}`);
    return false;
  }
  return true;
}

export async function removeStorage(key) {
  try {
    await localStorage.removeItem(key);
  } catch (e) {
    console.log(
      `removeStorage: Error removing key [${key}]: ${JSON.stringify(e)}`,
    );
    return false;
  }
  return true;
}

export function getStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.log(`getStorage: Error reading key [${key}]: ${JSON.stringify(e)}`);
    return null;
  }
}
